import { PlayerRequestType, PlayerError } from '@dtvgo/player-common-utils';
import { isAbsoluteURL } from '@dtvgo/utils';
import { isLicenseError } from './utils.js';

var ErrorGroup = /* @__PURE__ */ ((ErrorGroup2) => {
  ErrorGroup2["BUSINESS"] = "Bus";
  ErrorGroup2["TECHNICAL"] = "Tech";
  return ErrorGroup2;
})(ErrorGroup || {});
var ErrorCategory = /* @__PURE__ */ ((ErrorCategory2) => {
  ErrorCategory2["AUTHORIZATION"] = "Authorization";
  ErrorCategory2["NOT_IN_PACKAGE"] = "Authorization NIP";
  ErrorCategory2["CONCURRENCY_STREAMS"] = "Authorization CSM";
  ErrorCategory2["AUTHORIZATION_REGION"] = "Authorization Region";
  ErrorCategory2["AUTHENTICATION"] = "Authentication";
  ErrorCategory2["AUTHENTICATION_LOGOUT"] = "Authentication Logout";
  ErrorCategory2["BLACKOUT"] = "Blackout";
  ErrorCategory2["CDN"] = "CDN";
  ErrorCategory2["DRM"] = "DRM";
  ErrorCategory2["DEVICE_NETWORK"] = "Device Network";
  ErrorCategory2["DEVICE_OTHER"] = "Device Other";
  ErrorCategory2["MANIFEST"] = "Manifest";
  ErrorCategory2["PARENTAL"] = "Parental";
  ErrorCategory2["PLAYER_INIT"] = "Player init";
  ErrorCategory2["PLAYER_RENDER"] = "Player Render";
  ErrorCategory2["UNEXPECTED"] = "Unexpected";
  return ErrorCategory2;
})(ErrorCategory || {});
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["BLACKOUT"] = "01";
  ErrorCode2["NOT_AT_REGION"] = "05";
  ErrorCode2["CONCURRENCY_PER_USER"] = "07";
  ErrorCode2["CONCURRENCY_PER_CHANNEL"] = "08";
  ErrorCode2["CONCURRENCY_PER_DEVICE"] = "09";
  ErrorCode2["CONCURRENCY_PER_PROVIDER"] = "34";
  ErrorCode2["NOT_IN_PACKAGE"] = "18";
  ErrorCode2["DEVICE_LIMIT_REACHED"] = "21";
  ErrorCode2["PARENTAL_RESTRICTION"] = "30";
  ErrorCode2["REFRESH_TOKEN_REVOKED"] = "50";
  return ErrorCode2;
})(ErrorCode || {});
var LicenseErrorCodeIrdeto = /* @__PURE__ */ ((LicenseErrorCodeIrdeto2) => {
  LicenseErrorCodeIrdeto2[LicenseErrorCodeIrdeto2["TOKEN_EXPIRED"] = 100202] = "TOKEN_EXPIRED";
  LicenseErrorCodeIrdeto2[LicenseErrorCodeIrdeto2["ENTITLEMENTS"] = 130001] = "ENTITLEMENTS";
  LicenseErrorCodeIrdeto2[LicenseErrorCodeIrdeto2["GEOLOCATION"] = 130301] = "GEOLOCATION";
  LicenseErrorCodeIrdeto2[LicenseErrorCodeIrdeto2["PROXY"] = 130302] = "PROXY";
  LicenseErrorCodeIrdeto2[LicenseErrorCodeIrdeto2["CONCURRENCY"] = 130401] = "CONCURRENCY";
  LicenseErrorCodeIrdeto2[LicenseErrorCodeIrdeto2["DEVICE_CONCURRENCY"] = 130402] = "DEVICE_CONCURRENCY";
  return LicenseErrorCodeIrdeto2;
})(LicenseErrorCodeIrdeto || {});
var LicenseErrorCodeToolbox = /* @__PURE__ */ ((LicenseErrorCodeToolbox2) => {
  LicenseErrorCodeToolbox2[LicenseErrorCodeToolbox2["TOKEN_EXPIRED"] = 4009] = "TOKEN_EXPIRED";
  LicenseErrorCodeToolbox2[LicenseErrorCodeToolbox2["ENTITLEMENTS"] = 4037] = "ENTITLEMENTS";
  LicenseErrorCodeToolbox2[LicenseErrorCodeToolbox2["GEOLOCATION"] = 4039] = "GEOLOCATION";
  LicenseErrorCodeToolbox2[LicenseErrorCodeToolbox2["PROXY"] = 4040] = "PROXY";
  LicenseErrorCodeToolbox2[LicenseErrorCodeToolbox2["CONCURRENCY"] = 4024] = "CONCURRENCY";
  LicenseErrorCodeToolbox2[LicenseErrorCodeToolbox2["DEVICE_CONCURRENCY"] = 4025] = "DEVICE_CONCURRENCY";
  return LicenseErrorCodeToolbox2;
})(LicenseErrorCodeToolbox || {});
var AuthorizerErrorCode = /* @__PURE__ */ ((AuthorizerErrorCode2) => {
  AuthorizerErrorCode2["NOT_IN_PACKAGE"] = "CNIP";
  AuthorizerErrorCode2["CONCURRENCY_PER_USER"] = "SCLPU";
  AuthorizerErrorCode2["CONCURRENCY_PER_CHANNEL"] = "SCLPC";
  AuthorizerErrorCode2["CONCURRENCY_PER_PROVIDER"] = "SCLPP";
  AuthorizerErrorCode2["CONCURRENCY_PER_DEVICE"] = "SCDCA";
  AuthorizerErrorCode2["NOT_AT_REGION"] = "CNAR";
  AuthorizerErrorCode2["GOOGLE_PLAY_NOT_IN_PACKAGE"] = "CNIPGIABA";
  AuthorizerErrorCode2["REFRESH_TOKEN_REVOKED"] = "RRT";
  return AuthorizerErrorCode2;
})(AuthorizerErrorCode || {});
const entitlementsErrorParams = {
  group: "Bus" /* BUSINESS */,
  category: "Authorization NIP" /* NOT_IN_PACKAGE */,
  code: "18" /* NOT_IN_PACKAGE */
};
const geolocationErrorParams = {
  group: "Bus" /* BUSINESS */,
  category: "Authorization Region" /* AUTHORIZATION_REGION */,
  code: "05" /* NOT_AT_REGION */
};
const concurrencyPerUserErrorParams = {
  group: "Bus" /* BUSINESS */,
  category: "Authorization CSM" /* CONCURRENCY_STREAMS */,
  code: "07" /* CONCURRENCY_PER_USER */
};
const concurrencyPerChannelErrorParams = {
  group: "Bus" /* BUSINESS */,
  category: "Authorization CSM" /* CONCURRENCY_STREAMS */,
  code: "08" /* CONCURRENCY_PER_CHANNEL */
};
const concurrencyPerDeviceErrorParams = {
  group: "Bus" /* BUSINESS */,
  category: "Authorization CSM" /* CONCURRENCY_STREAMS */,
  code: "09" /* CONCURRENCY_PER_DEVICE */
};
const concurrencyPerProviderErrorParams = {
  group: "Bus" /* BUSINESS */,
  category: "Authorization CSM" /* CONCURRENCY_STREAMS */,
  code: "34" /* CONCURRENCY_PER_PROVIDER */
};
const generalAuthorizerErrorParams = {
  group: "Tech" /* TECHNICAL */,
  category: "Authorization" /* AUTHORIZATION */
};
const refreshTokenRevoked = {
  group: "Tech" /* TECHNICAL */,
  category: "Authorization" /* AUTHORIZATION */,
  code: "50" /* REFRESH_TOKEN_REVOKED */
};
const generalDrmErrorParams = {
  group: "Tech" /* TECHNICAL */,
  category: "DRM" /* DRM */
};
const getBlackoutError = (schedule, regions) => ({
  group: "Bus" /* BUSINESS */,
  category: "Blackout" /* BLACKOUT */,
  code: "01" /* BLACKOUT */,
  message: "The user's region is not available for the channel",
  data: {
    internalCode: "",
    originalError: {
      schedule,
      regions
    }
  }
});
const getParentalControlError = (contentRating, profileAgeRating, profileName) => {
  const parentalControlDetail = contentRating ? `Profile age rating allowed content: ${profileAgeRating} and less. Is not age rated content allowed for this profile: ${profileName}. Asset blocked age rating: ${contentRating}` : `Profile age rating allowed content: ${profileAgeRating} and less. Is not age rated content allowed for this profile: ${profileName}. Asset blocked does not have an age rating. This profile does not allow content without age restriction.`;
  return {
    group: "Bus" /* BUSINESS */,
    category: "Parental" /* PARENTAL */,
    code: "30" /* PARENTAL_RESTRICTION */,
    message: "Content has a higher rate than what is allowed to this profile.",
    data: {
      internalCode: "",
      originalError: {
        details: parentalControlDetail
      }
    }
  };
};
const AuthorizerErrorCodeToErrorParams = {
  ["CNIP" /* NOT_IN_PACKAGE */]: entitlementsErrorParams,
  ["CNIPGIABA" /* GOOGLE_PLAY_NOT_IN_PACKAGE */]: entitlementsErrorParams,
  ["SCLPU" /* CONCURRENCY_PER_USER */]: concurrencyPerUserErrorParams,
  ["SCLPC" /* CONCURRENCY_PER_CHANNEL */]: concurrencyPerChannelErrorParams,
  ["SCLPP" /* CONCURRENCY_PER_PROVIDER */]: concurrencyPerProviderErrorParams,
  ["SCDCA" /* CONCURRENCY_PER_DEVICE */]: concurrencyPerDeviceErrorParams,
  ["CNAR" /* NOT_AT_REGION */]: geolocationErrorParams,
  ["RRT" /* REFRESH_TOKEN_REVOKED */]: refreshTokenRevoked
};
function parseAuthorizerError(error) {
  const errorParams = AuthorizerErrorCodeToErrorParams[error.response?.data?.details] || generalAuthorizerErrorParams;
  const requestURL = error.config?.url && (isAbsoluteURL(error.config?.url) ? error.config.url : `${error.config?.baseURL || ""}${error.config?.url || ""}`);
  return {
    ...errorParams,
    data: {
      internalCode: error.code,
      requestURL,
      response: error.response ? {
        data: error.response.data,
        status: error.response.status,
        headers: error.response.headers,
        message: `${error.response.data?.code}|${error.response.data?.details || error.response.data?.message}`
      } : void 0,
      originalError: error
    }
  };
}
const LicenseErrorCodeToErrorParams = {
  [130301 /* GEOLOCATION */]: geolocationErrorParams,
  [130001 /* ENTITLEMENTS */]: entitlementsErrorParams,
  [130401 /* CONCURRENCY */]: concurrencyPerUserErrorParams,
  [130402 /* DEVICE_CONCURRENCY */]: concurrencyPerDeviceErrorParams
};
const LicenseTbxErrorCodeToErrorParams = {
  [4039 /* GEOLOCATION */]: geolocationErrorParams,
  [4037 /* ENTITLEMENTS */]: entitlementsErrorParams,
  [4024 /* CONCURRENCY */]: concurrencyPerUserErrorParams,
  [4025 /* DEVICE_CONCURRENCY */]: concurrencyPerDeviceErrorParams
};
const RequestTypeToCategory = {
  [PlayerRequestType.MANIFEST]: "CDN" /* CDN */,
  [PlayerRequestType.SEGMENT]: "CDN" /* CDN */,
  [PlayerRequestType.LICENSE]: "DRM" /* DRM */,
  [PlayerRequestType.SERVER_CERTIFICATE]: "DRM" /* DRM */
};
const PlayerErrorMapping = {
  [PlayerError.Category.NETWORK]: {
    group: "Tech" /* TECHNICAL */,
    category: "Unexpected" /* UNEXPECTED */
  },
  [PlayerError.Code.HTTP_ERROR]: {
    group: "Tech" /* TECHNICAL */,
    category: "Device Network" /* DEVICE_NETWORK */
  },
  [PlayerError.Code.BAD_HTTP_STATUS]: {
    group: "Tech" /* TECHNICAL */,
    category: (error) => RequestTypeToCategory[error.data?.requestType] || "Unexpected" /* UNEXPECTED */
  },
  [PlayerError.Code.TIMEOUT]: {
    group: "Tech" /* TECHNICAL */,
    category: "Device Network" /* DEVICE_NETWORK */
  },
  [PlayerError.Category.STREAMING]: {
    group: "Tech" /* TECHNICAL */,
    category: "Player Render" /* PLAYER_RENDER */
  },
  [PlayerError.Code.STREAMING_ERROR]: {
    group: "Tech" /* TECHNICAL */,
    category: "Device Other" /* DEVICE_OTHER */
  },
  [PlayerError.Category.MANIFEST]: {
    group: "Tech" /* TECHNICAL */,
    category: "Manifest" /* MANIFEST */
  },
  [PlayerError.Category.DRM]: generalDrmErrorParams,
  [PlayerError.Category.OTHER]: {
    group: "Tech" /* TECHNICAL */,
    category: "Unexpected" /* UNEXPECTED */
  },
  [PlayerError.Code.BAD_PLAYER_INITIALIZATION]: {
    group: "Tech" /* TECHNICAL */,
    category: "Player init" /* PLAYER_INIT */
  }
};
function parsePlayerError(error) {
  const {
    category,
    code,
    data: {
      uri,
      responseCode,
      responseHeaders,
      serverResponse
    } = {}
  } = error;
  let responseMessage;
  let serverResponseToUse = serverResponse;
  let errorParams;
  if (isLicenseError(error)) {
    if (serverResponse) {
      const parsedServerResponse = processLicenseFailedServerResponse(serverResponse);
      if (parsedServerResponse) {
        serverResponseToUse = parsedServerResponse;
        errorParams = LicenseErrorCodeToErrorParams[parsedServerResponse.code] || LicenseTbxErrorCodeToErrorParams[parsedServerResponse.code];
        responseMessage = `${parsedServerResponse?.code}|${parsedServerResponse?.message}`;
      }
    }
    if (!errorParams) {
      errorParams = generalDrmErrorParams;
    }
  }
  if (!errorParams) {
    errorParams = {};
    const mapping = PlayerErrorMapping[code] || PlayerErrorMapping[category];
    const categoryToUse = typeof mapping?.category === "function" ? mapping.category(error) : mapping.category;
    errorParams.group = mapping?.group;
    errorParams.category = categoryToUse;
  }
  return {
    ...errorParams,
    data: {
      internalCode: error?.toString(),
      requestURL: uri,
      response: responseCode ? {
        data: serverResponseToUse,
        headers: responseHeaders,
        status: responseCode,
        message: responseMessage
      } : void 0,
      originalError: error
    }
  };
}
const RECOVERABLE_ERRORS = /* @__PURE__ */ new Set([
  100202 /* TOKEN_EXPIRED */
]);
const RECOVERABLE_ERRORS_TBX = /* @__PURE__ */ new Set([
  4009 /* TOKEN_EXPIRED */
]);
const isRecoverableByReloading = (error) => {
  if (!isLicenseError(error) || !error.data?.serverResponse)
    return false;
  const { serverResponse, responseCode } = error.data;
  const { code } = processLicenseFailedServerResponse(serverResponse) || {};
  if (responseCode !== 401 && responseCode !== 403 || !code)
    return false;
  return RECOVERABLE_ERRORS.has(code) || RECOVERABLE_ERRORS_TBX.has(code);
};
function processLicenseFailedServerResponse(serverResponse) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(serverResponse, "application/xml");
  const parserError = doc.querySelector("parsererror");
  try {
    return parserError ? JSON.parse(serverResponse) : JSON.parse(doc.documentElement.getElementsByTagName("CustomData")[0].innerHTML);
  } catch (parseError) {
    console.error("Error constructing the License Error Object", parseError);
  }
  return void 0;
}

var errors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AuthorizerErrorCode: AuthorizerErrorCode,
  ErrorCategory: ErrorCategory,
  ErrorCode: ErrorCode,
  ErrorGroup: ErrorGroup,
  LicenseErrorCodeIrdeto: LicenseErrorCodeIrdeto,
  LicenseErrorCodeToolbox: LicenseErrorCodeToolbox,
  getBlackoutError: getBlackoutError,
  getParentalControlError: getParentalControlError,
  isRecoverableByReloading: isRecoverableByReloading,
  parseAuthorizerError: parseAuthorizerError,
  parsePlayerError: parsePlayerError
});

export { AuthorizerErrorCode as A, ErrorGroup as E, LicenseErrorCodeIrdeto as L, ErrorCategory as a, ErrorCode as b, LicenseErrorCodeToolbox as c, getParentalControlError as d, errors as e, parseAuthorizerError as f, getBlackoutError as g, isRecoverableByReloading as i, parsePlayerError as p };
//# sourceMappingURL=errors-d3c3631d.js.map
